// MyBlazon JS lib - v0.3.0.0 (semver: 3.0.0-beta)
import { ui } from './ui.js';
import { popup } from './popup.js';
import { system } from './system.js';
import { http } from './http.js';
import { api } from './api.js';
import { models } from './models.js';
import { shop } from './shop.js';
import { activity } from './activity.js';
import { viewmodels } from './viewmodels.js';

window.myblazon = {
    ui: ui,
    popup: popup,
    system: system,
    http: http,
    api: api,
    models: models,
    shop: shop,
    activity: activity,
    viewmodels: viewmodels,
}

$(document).ready(function () {

    // Initialize Slick.js
    var defaultSliderOptions = {
        autoplay: true,
        autoplaySpeed: 3000, // ms
        arrows: false,
        dots: false,
        infinite: true,
        pauseOnHover: false,
        lazyLoad: 'progressive'
    };

    $(".slider").each(function () {
        var $this = $(this);
        
        // Allow responsive breakpoints, and add defaultoptions to them
        let responsiveOptions = $this.data("sliderResponsive");
        if (responsiveOptions) {
            for(let i = 0; i < responsiveOptions.length; i++) {
                responsiveOptions[i].settings = $.extend({}, defaultSliderOptions, responsiveOptions[i].settings);
            }
        }

        let sliderOptions = $.extend({}, defaultSliderOptions, {
            slidesToShow: $this.data("sliderSlidestoshow"),
            slidesToScroll: $this.data("sliderSlidestoscroll"),
            autoplay: $this.data("sliderAutoplay"),
            responsive: responsiveOptions
        });

        if($this.hasClass("slider-pause-hover")) { sliderOptions.pauseOnHover = true; }
            
        $this.slick(sliderOptions);

        $(".slider-prev", $this).click(function (event) {
            event.preventDefault();
            $this.slickPrev();
        });

        $(".slider-next", $this).click(function (event) {
            event.preventDefault();
            $this.slickNext();
        });
    });

    $(".edit-slider").each(function () {
        var $this = $(this);
        //$this.autoplay = false;
        $this.slickPause();
        $this.slickSetOption("autoplay", false, true);
        $this.slickSetOption("infinite", false, true);
    });

    var sharePopup = new ui.SharePopup({ popupSelector: "#popup_preshare" });
    var urlToShare = $('#shieldlink_next').data("shareurl");
    var imgUrl = $('#imgurl').attr('src');
    if (typeof urlToShare !== 'undefined') {
        $(' .sharePreview').each(function () {
            console.log($(this).attr('src'));
            $(this).attr('src', imgUrl);
        });
    }
    $('#shieldlink_next.local').click(function () {

        sharePopup.show().done(function () {
            var login = $('#shieldlink_next.local').data("shouldlogin");
            if (login && login === true) { OpenLogInPopup($('#shieldlink_next.local').data("redirectaftershare")); }
            else { window.location.href = $('#shieldlink_next.local').data("redirectaftershare"); }
        })
            .fail(function () {
                var login = $('#shieldlink_next.local').data("shouldlogin");
                if (login && login === true) { OpenLogInPopup($('#shieldlink_next.local').data("redirectaftershare")); }
                else { window.location.href = $('#shieldlink_next.local').data("redirectaftershare"); }
            });
    });

    //$('.fbrefresh').click(function () {
    //    $('#form_ornaments').submit();
    //    window.FB.api("", 'post', { id: $(".fbrefresh").data("shareurl"), scrape: 'true' }, function () { });
    //});

    //change or set recipient of blason
    var $setRecBtn = $('#setRecipient button[type="button"]'),
        $setRecInput = $('#setRecipient .input-box');

    $setRecBtn.mousedown(function () {
        $setRecBtn.removeClass('selected');
        $setRecInput.hide();
        $(this).addClass('selected');
        $(this).next($setRecInput).show();
        var val = $(this).val();
        if (val !== "") {
            $('#setRecipient #recipientType').attr('value', val);
            $('#recipient_recipientType').attr('value', val);
        }

    });
    $("#sendCoaMail").click(function () {

        var displayError = function () {
            setTimeout(function () {
                $("#notsent").fadeIn('slow');
            }, 1000);


            setTimeout(function () {
                $("#notsent").fadeOut('slow');
            }, 5000);
        };

        if ($('#emails').val().length === 0) {
            displayError();
            return;
        }

        $.ajax({
            url: '/coatofarms/sendcoaemailapi',
            type: 'POST',
            data: 'sharedkey=' + $('#id').val() + '&link=' + $('#link').val() + '&emails=' + $('#emails').val(),
            beforeSend: function () {
                $("#sending").fadeIn('fast');
            },
            success: function () {
                setTimeout(function () {
                    $("#sent").fadeIn('slow');
                }, 1000);


                setTimeout(function () {
                    $("#sent").fadeOut('slow');
                }, 5000);
            },

            error: function (result, status, error) {
                console.log('Unable to send coat of arms email', result, status, error);
                displayError();
            },

            complete: function () {
                $("#sending").fadeOut('slow');
            }
        });
    });

    //for display page : opens toolbox, set saved option as 'selected' by default 
    $('#toolbox-opener').click(function () {
        var type = $(this).next('.inner-toolbox').data("recipienttype");
        $(".inner-toolbox").find('button').removeClass("selected");
        $(".inner-toolbox").find('input').hide();
        $(".inner-toolbox").find('button[value=' + type + ']').addClass("selected");
        $(this).next('.inner-toolbox').toggle('fast');
    });


    //for display page, displays more informations about values responsively
    $('#touch-trigger').click(function () {
        var $infos = $('#heroBox').find('#hoverInfo');
        if ($infos.hasClass('down')) {
            $infos.removeClass('down');
            $infos.addClass('up');
            $(this).addClass('active');
        } else {
            $infos.removeClass('up');
            $infos.addClass('down');
            $(this).removeClass('active');
        }
    });
});